import CornerCard from "../components/CornerCard";

function CornerCardWrap({ className = "" }) {
  return (
    <div className={`${className} flex flex-col items-end justify-end lg:-ml-48`}>
      <CornerCard />
    </div>
  );
}

export default CornerCardWrap;